import { useCurrentStateAndParams } from "@uirouter/react";
import { styled } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Banner, BannerPrimaryText } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
const BannerStyled = styled(Banner)`
    background-color: ${colorsPalettes.blue[100]};
    padding: 16px;
    margin-bottom: 24px;
    ${BannerPrimaryText} {
        font-weight: 500;
    }
`;
export const WWWNotificationBanner = () => {
    const isWWW = useCurrentStateAndParams()?.params?.country === "999";
    if (!isWWW) {
        return null;
    }

    return (
        <BannerStyled
            title={translate("website.topics.page.wwwbanner.title")}
            CustomIcon={
                <SWReactIcons
                    iconName="megaphone"
                    size="xl"
                />
            }
        />
    );
};
